<template>
  <PieChart :options="chartOptions"></PieChart>
</template>

<script>
import PieChart from '@wizer/core/components/chart/PieChart'
import ChartMixin from '@/mixins/ChartMixin'
import NumberFormatMixin from '@/mixins/NumberFormatMixin'

export default {
  name: 'PieChartWrapper',
  mixins: [ChartMixin, NumberFormatMixin],
  components: {
    PieChart,
  },
  created() {
    this.$store.dispatch('setIsFillMissingDates', false)
  },
  computed: {
    chartOptions() {
      if (this.chartData.series && this.chartData.series.length > 0) {
        return {
          series: {
            color: this.colorPalette,
            data: this.chartData.series[0].data.map((seriesValue, index) => ({
              name: this.chartData.categories[index],
              value: seriesValue,
            })),
            radius: '80%',
            center: ['50%', '55%'],
            label: {
              formatter: this.formatter,
            },
          },
          legend: {
            type: this.getLegendType('categories'),
          },
        }
      }
      return {}
    },
  },
  methods: {
    formatter(params) {
      return this.chartNumberFormatter(params.value)
    },
  },
}
</script>
